import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MessageCircle } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#1a1a1a] text-white py-12 border-t border-gray-800">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About */}
          <div>
            <h3 className="text-xl font-serif font-semibold mb-4 text-amber-400">Adina's Crafts</h3>
            <p className="text-white/80 text-sm">
              Handcrafted scented candles & resin designs. Unique, creative, and crafted to brighten your home.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-amber-400">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="text-white/80 hover:text-amber-400 transition-colors">Home</Link></li>
              <li><Link to="/shop" className="text-white/80 hover:text-amber-400 transition-colors">Shop</Link></li>
              <li><Link to="/about" className="text-white/80 hover:text-amber-400 transition-colors">About</Link></li>
              <li><Link to="/contact" className="text-white/80 hover:text-amber-400 transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-amber-400">Contact Us</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <a 
                  href="mailto:contact@adinascrafts.co.uk" 
                  className="flex items-center gap-2 text-white/80 hover:text-amber-400 transition-colors"
                >
                  <Mail className="w-4 h-4" />
                  contact@adinascrafts.co.uk
                </a>
              </li>
              <li>
                <a 
                  href="tel:+447818983777" 
                  className="flex items-center gap-2 text-white/80 hover:text-amber-400 transition-colors"
                >
                  <Phone className="w-4 h-4" />
                  07818 983 777
                </a>
              </li>
              <li>
                <a 
                  href="https://wa.me/447818983777?text=Hi%20Adina's%20Crafts!%20%F0%9F%91%8B"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-white/80 hover:text-[#25D366] transition-colors"
                >
                  <MessageCircle className="w-4 h-4" />
                  WhatsApp
                </a>
              </li>
            </ul>
            <div className="mt-4 pt-3 border-t border-gray-700">
              <p className="text-xs text-green-400 flex items-center gap-1">
                <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></span>
                Always Open
              </p>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-800 text-center text-sm text-white/60">
          <p>&copy; {new Date().getFullYear()} Adina's Crafts. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
